import { createContext } from 'react';

const FabContext = createContext();

export default FabContext;
